import React from 'react';

const ScreenContainer = (props) => {
  return (
    <div className="container">
      {props.children}
    </div>
  );
};

export default ScreenContainer;
